// extracted by mini-css-extract-plugin
export default {"section":"JoinUs_section__rH5Ht","sec-desc":"JoinUs_sec-desc__rBA+F","ul-btn":"JoinUs_ul-btn__6TgaC","ul":"JoinUs_ul__Mh2V6","btn":"JoinUs_btn__nRIWJ"};